import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Avatar, Typography, Descriptions, Tag, List, Row, Col } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { fetchProfile } from "../store/profileApi/profileThunk";

const { Title } = Typography;

export default function ProfileDashboard() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.profileApi || {});

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  if (!profile) {
    return <p>Yuklanmoqda...</p>;
  }

  return (
    <div style={{ padding: 24 }}>
      <Row gutter={[24, 24]}>
        {/* Shaxsiy ma'lumotlar */}
        <Col xs={24} md={8}>
          <Card bordered={false} style={{ textAlign: "center" }}>
            <Avatar
              size={120}
              src={profile.picture}
              icon={<UserOutlined />}
              style={{ marginBottom: 16 }}
            />
            <Title level={4} style={{ marginBottom: 13 }}>
              {profile.surname} {profile.first_name}
            </Title>
            
            {/* <Tag color="blue">ID: {profile.id}</Tag> */}
          </Card>
        </Col>

        {/* Asosiy ma'lumotlar */}
        <Col xs={24} md={16}>
          <Card title="Asosiy ma'lumotlar" bordered={false}>
            <Descriptions bordered column={1} size="middle">
              <Descriptions.Item label="Ismi">
                {profile.first_name}
              </Descriptions.Item>
              <Descriptions.Item label="Familiyasi">
                {profile.surname}
              </Descriptions.Item>
              <Descriptions.Item label="Otasining ismi">
                {profile.patronymic}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>

      {/* Ish joylari */}
      <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        <Col span={24}>
          <Card title="Bo‘limlar va Lavozimlar" bordered={false}>
            <List
              itemLayout="vertical"
              dataSource={profile.departments || []}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <strong>{item.department_name?.name}</strong>
                    }
                    description={
                      <>
                        <p>
                          <strong>Lavozim:</strong>{" "}
                          {item.staff_position?.name}
                        </p>
                        <p>
                          <strong>Holati:</strong>{" "}
                          <Tag color={item.employee_status?.name === "Ishlamoqda" ? "green" : "red"}>
                            {item.employee_status?.name}
                          </Tag>
                        </p>
                        <p>
                          <strong>Xodim turi:</strong>{" "}
                          {item.employee_type?.name}
                        </p>
                        <p>
                          <strong>Ish shakli:</strong>{" "}
                          {item.employment_form?.name}
                        </p>
                        <p>
                          <strong>Shtat stavkasi:</strong>{" "}
                          {item.employment_staff?.name}
                        </p>
                      </>
                    }
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
